/*
 * @Description: 登陆回调地址
 * @Author: kadenwang@tencent.com
 * @Date: 2021-12-06 19:24:34
 * @LastEditors: yanxia@tencent.com
 * @LastEditTime: 2022-04-14 10:49:12
 */


import { isAppMarket } from '@tencent/syzs-login-sdk-utils';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { getUrlParam, itemLoginTypeKey, LoginRequest } from '../../lib';
import { ILoginType } from '../../types';


const LoginCallBack = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const callBackAsync = async () => {
      const code = getUrlParam('code');

      if (code) {
        const loginType = localStorage.getItem(itemLoginTypeKey);

        if (loginType) {
          await LoginRequest.code2AccessToken(code, loginType as ILoginType);
          localStorage.removeItem(itemLoginTypeKey);
        }
      } else {
        window.aegis.infoAll(`logincallback not code: ${location.href}`);
        if (isAppMarket()) {
          location.href = `${location.origin + location.pathname}#/Login`;
        } else {
          // 端外直接关闭打开的新窗口即可
          window.close();
        }
      }
    };

    void callBackAsync();
  }, [pathname]);

  return null;
};

export default LoginCallBack;
